<template>
  <v-layout row wrap class="pt-2" data-qa="paymentstatus-layout-fm2bue">
    <v-flex class="pb-2" v-if="showCustomList" data-qa="paymentstatus-flex-6u3gj">
      <v-flex xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="paymentstatus-flex-q89agh">
        <v-chip-group v-model="defaultFilter" :color="primaryColor" mandatory data-qa="paymentstatus-chip-group-ugk31q">
          <v-chip outlined class="ma-2" @click="showCustomFilterList(); resetFormattedDate();" data-qa="paymentstatus-chip-qcu3u">
            {{ $t("accountTransaction.customFilter") }}
          </v-chip>
          <v-chip
            v-if="chip4"
            outlined
            class="ma-2"
            @click="last7DaysTransactions"
           data-qa="paymentstatus-chip-stpiic">
            {{ $t("accountTransaction.last7Days") }}
          </v-chip>
          <v-chip
            v-if="chip3"
            outlined
            class="ma-2"
            @click="last15DaysTransactions"
           data-qa="paymentstatus-chip-1aomu">
            {{ $t("accountTransaction.last15Days") }}
          </v-chip>
          <v-chip
            v-if="chip1"
            outlined
            class="ma-2"
            @click="thisMonthTransactions"
           data-qa="paymentstatus-chip-fldj9n">
            {{ $t("accountTransaction.thisMonth") }}
          </v-chip>
            <v-chip
              v-if="chip2"
              outlined
              class="ma-2"
              @click="lastMonthTransactions"
             data-qa="paymentstatus-chip-ys61rr">
              {{ $t("accountTransaction.lastMonth") }}
            </v-chip>
        </v-chip-group>
      </v-flex>

      <v-expand-x-transition data-qa="paymentstatus-expand-x-transition-mncp1">
        <v-flex xs12 sm12 md6 lg6 xl6 data-qa="paymentstatus-flex-6w2pdv">
          <v-row no-gutters v-show="expandCustomList" data-qa="paymentstatus-row-8ipfrd">
            <v-flex class="pl-4 pr-4 md-4" xs5 sm5 md4 lg4 xl4 data-qa="paymentstatus-flex-332huh">
              <v-menu
                min-width="auto"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="paymentstatus-menu-kbcknk">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedFromDate"
                    :label="$t('accountTransaction.fromDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="fromDate"
                    :error="rangeExceeded"
                    :error-messages="
                        rangeExceeded && fromDateError
                        ? $t('paymentStatusEnquiry.dateRangeError')
                        : invalidDates && fromDateError ? $t('paymentStatusEnquiry.invalidDateError') : ''
                        "
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  @input="menu = false"
                  :max="currentDate"
                  data-qa="fromDate"
                  :color="primaryColor"
                  @change="updateFormattedDate('fromDate')"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="pl-4 pr-2 md-4" xs5 sm5 md4 lg4 xl4 data-qa="paymentstatus-flex-5c4wj">
              <v-menu
                min-width="auto"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="paymentstatus-menu-np1xhg">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedToDate"
                    :label="$t('accountTransaction.toDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="toDate"
                    :error="rangeExceeded"
                    :error-messages="
                        rangeExceeded && toDateError
                        ? $t('paymentStatusEnquiry.dateRangeError')
                        : invalidDates && toDateError ? $t('paymentStatusEnquiry.invalidDateError') : ''
                        "
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  @input="menu2 = false"
                  :max="currentDate"
                  data-qa="toDate"
                  :color="primaryColor"
                  @change="updateFormattedDate('toDate')"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs1 sm1 md2 lg1 xl1 class="pl-2 pr-4 pt-4 md-4" data-qa="paymentstatus-flex-cmjw7u">
              <v-btn
                fab
                outlined
                small
                :color="primaryColor"
                :disabled="rangeExceeded || invalidDates"
                @click="getPaymentStatus(accountNumber, fromDate, toDate)"
                data-qa="getCustomTransaction"
              >
                <v-icon dark class="material-symbols-outlined" data-qa="paymentstatus-icon-ihjawj">arrow_right_alt</v-icon>
              </v-btn>
            </v-flex>
          </v-row>
        </v-flex>
      </v-expand-x-transition>
      <v-flex xs12 sm12 md8 lg6 xl6 class="pa-2 ml-3" data-qa="paymentstatus-flex-9u68e">
          <v-card class="text-left status--hover" data-qa="paymentstatus-card-sbw0l">
              <div v-for="(item, index) in payments.paymentsList" :key="item.paymentId" :data-qa="`paymentstatus-div-df7lr-${index}`">
              <v-list-item two-line @click="selectedPayment(item,index)" :data-qa="`paymentstatus-list-item-j0wytl-${index}`">
                <v-list-item-content :data-qa="`paymentstatus-list-item-content-5nothj-${index}`">
                    <div class="overline mb-0" :data-qa="`paymentstatus-div-vxlnr5-${index}`">
                        <font class="subtitle-2 font-weight-normal ml-2">{{item.creditorName}}</font>
                    </div>
                    <v-list-item-subtitle class="mb-0 ml-2" :data-qa="`paymentstatus-list-item-subtitle-xprj0l-${index}`">{{
                    $formatter.formatDate(item.interbankSettlementDate.substr(0, 10))
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action :data-qa="`paymentstatus-list-item-action-867414-${index}`">
                  <v-list-item-action-text :data-qa="`paymentstatus-list-item-action-text-l9id8i-${index}`">
                    <font
                      class="subtitle-1 font-weight-bold"
                      >{{
                        $formatter.currency.format(item.amount.amount, item.amount.currency)
                      }}</font
                    >
                  </v-list-item-action-text>
                  <v-list-item-action-text :data-qa="`paymentstatus-list-item-action-text-1ckhit-${index}`">
                    <font :color="getColor(item.status)" class="subtitle-2 font-weight-bold">{{ getStatus(item.status) }}</font>
                  </v-list-item-action-text>
                </v-list-item-action>
                <v-icon class="text-end" :data-qa="`paymentstatus-icon-udogpf-${index}`">mdi-chevron-right</v-icon>
              </v-list-item>
              <v-divider :data-qa="`paymentstatus-divider-fflr4k-${index}`"></v-divider>
              </div>
              <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
          </v-card>
        <Modal
          :config="getSuccessModalConfig"
          @cancel="successModal.enabled = false"
          @btn3Action="downloadPaymentProofEnabled"
        >
        </Modal>
      </v-flex>
    </v-flex>
    <v-flex class="pa-2 ml-3 text-left" xs12 sm12 md8 lg8 xl8 v-if="!(payments && payments.paymentsList)" data-qa="paymentstatus-flex-uu987m">
      <span data-qa="paymentstatus-span-mgkmf">
        <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="paymentstatus-alert-9np0aj">
          <font class="body-2">{{ $t('paymentStatusEnquiry.noPaymentsFound') }}</font>
        </v-alert>
      </span>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import event from '@/util/event'
import CommonService from '@/service/commonService.js'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

export default {
  name: 'PaymentStatus',
  props: {
    config: String
  },
  components: {
    DownloadPaymentProof,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      fromDateError: false,
      toDateError: false,
      invalidDates: false,
      rangeExceeded: false,
      showCustomList: true,
      defaultFilter: 1,
      expandCustomList: false,
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
      menu: false,
      menu2: false,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      currentDate: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      showDetails: false,
      statusDetails: '',
      accountNumber: '',
      limit: 30,
      payments: {},
      successModal: {
        enabled: false,
        persistent: true,
        close: true,
        dataListTranslation: 'accountDetails.paymentStatusTab',
        title: this.$t('accountDetails.paymentStatusTab.title'),
        width: 600
      },
      paymentProofDetails: {},
      downloadDataDetails: [],
      showDownloadPayment: false,
      selectedPaymentId: '',
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
      // loaderEnabled: false
    }
  },
  created () {
    this.resetFormattedDate()
    this.accountNumber = this.config
    this.last7DaysTransactions()
    if (this.isDownloadPaymentProofEnabled) {
      this.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  computed: {
    getSuccessModalConfig () {
      return {
        ...this.successModal,
        dataDetails: [
          {
            label: 'creditorName',
            value: this.statusDetails.creditorName
          },
          {
            label: 'creditorAccNum',
            value: this.statusDetails.creditorAccount
          },
          {
            label: 'amount',
            value: this.$formatter.currency.format(this.statusDetails?.amount?.amount, this.statusDetails?.amount?.currency)
          },
          {
            label: 'status',
            value: this.getStatus(this.statusDetails.status)
          },
          {
            label: 'date',
            value: this.$formatter.formatDate(this.statusDetails.interbankSettlementDate)
          },
          {
            label: 'transactionReference',
            value: this.statusDetails.paymentId
          }
        ]
      }
    }
  },
  methods: {
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    showCustomFilterList () {
      this.expandCustomList = true
    },
    getDate (val) {
      return moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
    },
    resetFormattedDate () {
      this.fromDate = moment().format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.formattedFromDate = this.$formatter.formatDate(this.currentDate)
      this.formattedToDate = this.$formatter.formatDate(this.currentDate)
    },
    thisMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(30)
      self.getPaymentStatus(this.accountNumber, startDate, endDate)
    },
    lastMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(60)
      self.getPaymentStatus(this.accountNumber, startDate, endDate)
    },
    last15DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(15)
      self.getPaymentStatus(this.accountNumber, startDate, endDate)
    },
    last7DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(7)
      self.getPaymentStatus(this.accountNumber, startDate, endDate)
    },
    updateFormattedDate (fieldName) {
      const startDate = moment(this.fromDate, 'YYYY-MM-DD')
      const endDate = moment(this.toDate, 'YYYY-MM-DD')
      const diff = endDate.diff(startDate, 'days')
      if (Math.sign(diff) && Math.sign(diff) !== -1) {
        if (diff > 60) {
          this.rangeExceeded = true
          this.invalidDates = false
          if (fieldName === 'toDate') {
            this.toDateError = true
            this.fromDateError = false
          } else {
            this.fromDateError = true
            this.toDateError = false
          }
        } else {
          this.rangeExceeded = false
          this.invalidDates = false
          this.fromDateError = false
          this.toDateError = false
        }
      } else {
        this.rangeExceeded = false
        this.invalidDates = true
        if (fieldName === 'toDate') {
          this.toDateError = true
          this.fromDateError = false
        } else {
          this.fromDateError = true
          this.toDateError = false
        }
      }
      if (diff === 0) {
        this.rangeExceeded = false
        this.fromDateError = false
        this.toDateError = false
        this.invalidDates = false
      }
      this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
      this.formattedToDate = this.$formatter.formatDate(this.toDate)
    },
    async getPaymentStatus (accountNumber, fromDate, toDate) {
      try {
        this.payments = await CommonService.paymentStatusEnquiry(accountNumber, fromDate, toDate, this.limit)
      } catch (e) {
        console.log(e)
      }
    },
    getStatus (status) {
      switch (status) {
        case 'INITIATED': return 'PROCESSING'
        case 'PROCESSED': return 'PROCESSED'
        case 'CANCELLED': return 'FAILED'
        case 'REJECTED': return 'FAILED'
        case 'RETURNED': return 'RETURNED'
        case 'COMPLIANCE FAILED': return 'FAILED'
        case 'AUTHORISATION REJECTED': return 'FAILED'
        default:
      }
    },
    getColor (status) {
      switch (status) {
        case 'INITIATED': return '#F4BC1C'
        case 'PROCESSED': return 'green'
        case 'CANCELLED': return 'red'
        case 'REJECTED': return 'red'
        case 'RETURNED': return '#F4BC1C'
        case 'COMPLIANCE FAILED': return 'red'
        case 'AUTHORISATION REJECTED': return 'red'
        default:
      }
    },
    selectedPayment (item, index) {
      this.showDetails = this.successModal.enabled = true
      this.statusDetails = item,
      this.selectedPaymentId = item?.paymentId
    },
    capitalizeFirst (text = '') {
      return text.toLowerCase().replace(/^\w/, c => c.toUpperCase());
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      this.downloadDataDetails = []
      this.downloadDataDetails.push(
        { label: 'fromAcc', value: this.$formatter.maskNumber(this.accountNumber)},
        { label: 'toAcc', value: this.$formatter.maskNumber(this.statusDetails?.creditorAccount)},
        { label: 'amount', value: this.$formatter.currency.format(this.statusDetails?.amount?.amount, this.statusDetails?.amount?.currency)},
        { label: 'paymentDate', value: this.$formatter.formatDate(this.statusDetails?.interbankSettlementDate)}
      )
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.selectedPaymentId },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.getStatus(this.statusDetails?.status) ? this.$formatter.convertCase.firstLetterUpper(this.getStatus(this.statusDetails?.status)) : '-' }
      ]
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      this.paymentProofDetails = {
        dataDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        titleContentDetails,
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.selectedPaymentId
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
      // this.showDownloadPayment = true
    }
  },
  beforeDestroy () {
    event.$off('download_payment_proof')
  }
}
</script>
<style lang="scss" scoped>
.status{
&--hover {
cursor: pointer;
}
}
</style>
